var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "hb-section",
    {
      attrs: {
        title: _vm.$t("influencer_panel.tab_links"),
        subtitle: _vm.summary,
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "sm" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("generate-link")
                    },
                  },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "PlusIcon", size: "14" },
                  }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("influencer_panel.generate_link")) + " "
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      !_vm.links.length
        ? _c("hb-empty-state", {
            attrs: {
              title: _vm.$t("influencer_panel.no_links"),
              icon: "LinkIcon",
            },
          })
        : _c(
            "div",
            [
              _vm._l(_vm.links, function (link) {
                return _c("div", { key: link.id, staticClass: "links__row" }, [
                  _c("div", { staticClass: "links__identity" }, [
                    _c("div", { staticClass: "links__name" }, [
                      _vm._v(_vm._s(_vm.linkName(link))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "links__url" },
                      [
                        _c("feather-icon", {
                          attrs: { icon: "LinkIcon", size: "13" },
                        }),
                        _c("code", [_vm._v(_vm._s(link.short_url))]),
                      ],
                      1
                    ),
                    _vm.couponCode(link)
                      ? _c(
                          "div",
                          { staticClass: "links__coupon" },
                          [
                            _c("feather-icon", {
                              attrs: { icon: "TagIcon", size: "13" },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("influencer_panel.link_coupon_note", {
                                    code: _vm.couponCode(link),
                                  })
                                ) +
                                " "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "links__stat" }, [
                    _c("div", { staticClass: "links__stat-label" }, [
                      _vm._v(_vm._s(_vm.$t("influencer_panel.clicks"))),
                    ]),
                    _c("div", { staticClass: "links__stat-value" }, [
                      _vm._v(
                        _vm._s(
                          Number(link.clicks_count || 0).toLocaleString("pt-BR")
                        )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "links__stat" }, [
                    _c("div", { staticClass: "links__stat-label" }, [
                      _vm._v(_vm._s(_vm.$t("influencer_panel.sales"))),
                    ]),
                    _c("div", { staticClass: "links__stat-value" }, [
                      _vm._v(_vm._s(link.conversions || 0)),
                    ]),
                  ]),
                  _c("div", { staticClass: "links__stat" }, [
                    _c("div", { staticClass: "links__stat-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("influencer_panel.conversion_rate"))
                      ),
                    ]),
                    _c("div", { staticClass: "links__stat-value" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Number(link.conversion_rate || 0).toLocaleString(
                              "pt-BR",
                              { maximumFractionDigits: 2 }
                            )
                          ) +
                          "% "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "links__actions" },
                    [
                      _c("hb-copy-button", {
                        attrs: {
                          text: link.short_url,
                          "share-title": _vm.linkName(link),
                        },
                      }),
                    ],
                    1
                  ),
                ])
              }),
              _c(
                "p",
                { staticClass: "links__note" },
                [
                  _c("feather-icon", {
                    attrs: { icon: "InfoIcon", size: "13" },
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("influencer_panel.links_sales_note")) +
                      " "
                  ),
                ],
                1
              ),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }